import { ReactNode } from "react";
import {
    Document24Icon,
    Excel24Icon,
    File24Icon,
    Image24Icon,
    Pdf24Icon,
    Play24Icon,
    Slide24Icon,
    Sound24Icon,
    ZipFile24Icon,
} from "@kaltura/ds-react-icons";

const attachmentTypeMap: Record<string, string> = Object.fromEntries(
    Object
        .entries({
            document: ["doc", "docx", "odt", "rtf", "tex", "txt", "wpd"],
            pdf: ["pdf"],
            data: ["xls", "xlsx", "xlsm", "ods", "csv", "dat", "db", "log", "mdb", "sav", "sql", "tar", "xml"],
            presentation: ["key", "odp", "pps", "ppt", "pptx"],
            audio: ["mp3", "aif", "cda", "mid", "mpa", "ogg", "wav", "wma", "wpl"],
            image: ["ai", "jpg", "bmp", "gif", "ico", "jpeg", "png", "ps", "psd", "svg", "tif"],
            video: ["3g2", "3gp", "avi", "flv", "h264", "m4v", "mkv", "mov", "mp4", "mpg", "rm", "swf", "vob", "wmv"],
            archive: ["7z", "arj", "deb", "pkg", "rar", "rpm", "gz", "tar", "z", "zip"],
        })
        .flatMap(([type, extensions]) => extensions.map((ext) => [ext, type]))
);

const iconsMap: Record<string, ReactNode> = {
    document: <Document24Icon className={"filetype-icon"} />,
    pdf: <Pdf24Icon className={"filetype-icon"} />,
    data: <Excel24Icon className={"filetype-icon"} />,
    presentation: <Slide24Icon className={"filetype-icon"} />,
    audio: <Sound24Icon className={"filetype-icon"} />,
    image: <Image24Icon className={"filetype-icon"} />,
    video: <Play24Icon className={"filetype-icon"} />,
    archive: <ZipFile24Icon className={"filetype-icon"} />,
    other: <File24Icon className={"filetype-icon"} />,
};

/**
 * Returns the appropriate file-type icon for a given file extension.
 * Falls back to a generic file icon for unrecognised extensions.
 */
export const getFileTypeIcon = (fileExt: string): ReactNode =>
    iconsMap[attachmentTypeMap[fileExt?.toLowerCase()] ?? "other"];
